import {BlogComponent} from '../blog/blog.component';

new BlogComponent();
